/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-floating-promises */

import FormattedMessage from 'I18n/components/FormattedMessage';
import ExamQuestion from './ExamQuestion';
import ExamTimer from './ExamTimer';
import { useSubmitExamQuestion, useValidateExam } from '../';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
import QuizTopbar from '../../../components/QuizTopbar';
import { useCallback, useEffect, useState } from 'react';
import { useMostRecentExamAttempt } from '../../exams';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import ExamLoadingScreen from './ExamLoadingScreen';
import { useFullTrack } from '../../tracks';
import UsageTracker from '../../../utils/UsageTracker';
import { Metrics } from '../../../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_CLASS_NAME = 'exam-question-screen';
const ExamQuestionScreen = ({
  trackId,
  language
}) => {
  const [selectedAnswerIds, setSelectedAnswerIds] = useState([]);
  const {
    track,
    trackLoading
  } = useFullTrack(trackId, language);
  const {
    mostRecentExamAttempt,
    mostRecentExamAttemptLoading
  } = useMostRecentExamAttempt(trackId, language);
  const [submitExamQuestion, {
    submitExamQuestionLoading,
    submitExamQuestionError
  }] = useSubmitExamQuestion();
  const [validateExam, {
    validateExamLoading,
    validateExamError
  }] = useValidateExam();
  const totalQuestionCount = mostRecentExamAttempt ? mostRecentExamAttempt.questions.length : 0;
  const currentQuestionIndex = mostRecentExamAttempt ? Math.max(0, Math.min(mostRecentExamAttempt.questionSubmissions.length, totalQuestionCount - 1)) : 0;
  const currentQuestion = mostRecentExamAttempt && mostRecentExamAttempt.questions[currentQuestionIndex];
  const isLastQuestion = currentQuestionIndex + 1 >= totalQuestionCount;
  const handleClickNext = useCallback(() => {
    if (!currentQuestion || !selectedAnswerIds.length) return null;
    return submitExamQuestion(trackId, mostRecentExamAttempt.id, currentQuestion.id, selectedAnswerIds).then(() => {
      setSelectedAnswerIds([]);
      Metrics.counter('exam-question-answered', {
        lannguae: mostRecentExamAttempt.language
      }).increment();
      if (isLastQuestion) {
        return validateExam(Number(trackId), mostRecentExamAttempt.id).then(() => {
          UsageTracker.track('examInteraction', {
            action: 'completed',
            examId: track && track.exam.id,
            examLength: mostRecentExamAttempt.questions.length,
            trackId: trackId && trackId.toString(),
            trackName: track && track.name,
            examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString(),
            language: mostRecentExamAttempt.language
          });
          Metrics.counter('exam-completed', {
            language: mostRecentExamAttempt.language
          }).increment();
        });
      }
      const completionPercentage = +((currentQuestionIndex + 1 / totalQuestionCount) * 100).toFixed(2);
      UsageTracker.track('examInteraction', {
        action: 'progress',
        examId: track && track.exam.id,
        examLength: mostRecentExamAttempt.questions.length,
        trackId: trackId && trackId.toString(),
        trackName: track && track.name,
        examAttemptId: mostRecentExamAttempt.id && mostRecentExamAttempt.id.toString(),
        completionPercentage,
        language: mostRecentExamAttempt.language
      });
      return null;
    });
  }, [currentQuestion, currentQuestionIndex, isLastQuestion, mostRecentExamAttempt, selectedAnswerIds, submitExamQuestion, totalQuestionCount, track, trackId, validateExam]);
  useEffect(() => {
    const handleKeydown = event => {
      if (event.key === 'Enter' && selectedAnswerIds.length && !(submitExamQuestionLoading || validateExamLoading)) {
        handleClickNext();
      }
    };
    document.addEventListener('keydown', handleKeydown);
    return () => document.removeEventListener('keydown', handleKeydown);
  }, [currentQuestionIndex, handleClickNext, selectedAnswerIds.length, submitExamQuestionLoading, validateExamLoading]);
  if (mostRecentExamAttemptLoading || trackLoading) return /*#__PURE__*/_jsx(ExamLoadingScreen, {});
  if (!mostRecentExamAttempt || !currentQuestion || !track) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: BASE_CLASS_NAME,
    children: [/*#__PURE__*/_jsxs("div", {
      className: `${BASE_CLASS_NAME}__content-area`,
      children: [/*#__PURE__*/_jsx(QuizTopbar, {
        className: `${BASE_CLASS_NAME}__topbar`,
        currentQuestion: currentQuestionIndex + 1,
        numQuestions: totalQuestionCount,
        topRightComponent: /*#__PURE__*/_jsx(ExamTimer, {
          language: language,
          trackId: trackId
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: `${BASE_CLASS_NAME}__question`,
        children: [/*#__PURE__*/_jsx("h2", {
          children: currentQuestion.question
        }), /*#__PURE__*/_jsx(ExamQuestion, {
          language: language,
          onSelectAnswer: setSelectedAnswerIds,
          selectedAnswerIds: selectedAnswerIds,
          trackId: trackId
        })]
      })]
    }), /*#__PURE__*/_jsx(ContentControlWrapper, {
      className: `${BASE_CLASS_NAME}__content-control`,
      children: /*#__PURE__*/_jsx(UILoadingButton, {
        "data-test-id": "exam-next-question-button",
        disabled: selectedAnswerIds.length <= 0,
        failed: !!submitExamQuestionError || !!validateExamError,
        loading: submitExamQuestionLoading || validateExamLoading,
        onClick: handleClickNext,
        preventClicksOnLoading: submitExamQuestionLoading || validateExamLoading,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.exams.examQuestion.nextButton"
        })
      })
    })]
  });
};
export default ExamQuestionScreen;